import About from "../pages/about/About";
import Contact from "../pages/contact/Contact";
import Home from "../pages/home/Home";
import TaskFeaturesTab from "../pages/apitasks/apitask1/APIReqRes";
import APItasks from "../pages/apitasks/APItasks";
import Covid from "../pages/apitasks/apitask2/Covid";
import Projects from "../pages/projects/covid/Projects";
import Dashboard from "../pages/projects/covid/Dashboard";
import StudentForm from "../pages/projects/GradeHistory/StudentForm";
import GradeDisplay from "../pages/projects/GradeHistory/GradeDisplay";
import VoterFormDataDisplay from "../pages/projects/VoterForm/VoterFormDataDisplay";
import { DynamicStudent } from "../pages/projects/dynamicStudentForm/Dynamic Form/DynamicStudent";
import { DisplayStudentData } from "../pages/projects/dynamicStudentForm/Dynamic Form/DisplayStudentData";
import LanDetect from "../pages/projects/languagedetection/LanDetect";
import Firebase from "../pages/projects/firebase/Firebase";
import ToDoHome from "../pages/projects/todo/components/ToDoHome";
import Weather from "../pages/projects/weather/Weather";
import Calculator from "../pages/projects/calculator/Calculator";
import PostsHome from "../pages/apitasks/apitask3/PostsHome";
import Form1 from "../pages/useform/Form1";
import QuizHome from "../pages/projects/quizapp/components/QuizHome";
import QuizHomeAPI from "../pages/apitasks/apitask4_quizapp/quizapp/components/QuizHomeAPI";
import SchedulerHome from "../pages/projects/scheduler/SchedulerHome";
import ProductsHome from "../pages/apitasks/products/componenets/ProductsHome";
import VoterForm from "../pages/projects/VoterForm/VoterForm";
import CourseEnrollment from "../pages/formik/CourseEnrollment";
import FormHome from "../pages/formik/FormHome";
import { RegisterFormik } from "../pages/formik/RegisterFormik";
import { FormContainer } from "../pages/formik/FormContainer";
import RegisterForm from "../pages/formik/properFormTask/RegisterForm";
import SingleProduct from "../pages/apitasks/products/componenets/SingleProduct";
import Cart from "../pages/apitasks/products/componenets/Cart";
import Debouncedemo from "../pages/practice/debounce/Debouncedemo";
import LockUnLock from "../pages/toggleCustomHook/LockUnLock";
import MultiSelectDropDown from "../pages/practice/MultiSelectDropDown";
import PracticeHome from "../pages/practice/PracticeHome";

export const PUBLIC_ROUTES = [
  {
    id: 1,
    path: "/",
    element: <Home />,
  },
  {
    id: 1,
    path: "/about",
    element: <About />,
  },
  {
    id: 3,
    path: "/apitasks",
    element: <APItasks />,
  },
  {
    id: 4,
    path: "/contact",
    element: <Contact />,
  },
  {
    id: 5,
    path: "/apitasks/1",
    element: <TaskFeaturesTab />,
  },
  {
    id: 5,
    path: "/apitasks/2",
    element: <Covid />,
  },
  {
    id: 6,
    path: "/projects",
    element: <Projects />,
  },
  {
    id: 7,
    path: "/projects/1",
    element: <Dashboard />,
  },
  {
    id: 8,
    path: "/projects/2",
    element: <StudentForm />,
  },
  {
    id: 8,
    path: "/projects/2/gradedisplay",
    element: <GradeDisplay />,
  },
  {
    id: 9,
    path: "/projects/3",
    element: <VoterForm />,
  },
  {
    id: 10,
    path: "/projects/3/datadisplay",
    element: <VoterFormDataDisplay />,
  },
  {
    id: 11,
    path: "/projects/4",
    element: <DynamicStudent />,
  },
  {
    id: 12,
    path: "/projects/4/students",
    element: <DisplayStudentData />,
  },
  {
    id: 13,
    path: "/projects/5",
    element: <LanDetect />,
  },
  {
    id: 14,
    path: "/projects/6",
    element: <Firebase />,
  },
  {
    id: 15,
    path: "projects/todo",
    element: <ToDoHome />,
  },
  {
    id: 16,
    path: "projects/weather",
    element: <Weather />,
  },
  {
    id: 17,
    path: "projects/calculator",
    element: <Calculator />,
  },
  {
    id: 18,
    path: "APItasks/3",
    element: <PostsHome />,
  },
  {
    id: 19,
    path: "/useform",
    element: <Form1 />,
  },
  {
    id: 20,
    path: "projects/quizapp",
    element: <QuizHome />,
  },
  {
    id: 21,
    path: "apitasks/quizapp",
    element: <QuizHomeAPI />,
  },
  {
    id: 22,
    path: "projects/scheduler",
    element: <SchedulerHome />,
  },
  {
    id: 23,
    path: "apitasks/products",
    element: <ProductsHome />,
  },
  {
    id: 23,
    path: "apitasks/products/:id",
    element: <SingleProduct />,
  },
  {
    id: 23,
    path: "apitasks/cart",
    element: <Cart />,
  },
  {
    id: 24,
    path: "form",
    element: <FormHome />,
  },
  {
    id: 25,
    path: "form/1",
    element: <CourseEnrollment />,
  },
  {
    id: 26,
    path: "form/2",
    element: <RegisterFormik />,
  },
  {
    id: 27,
    path: "form/3",
    element: <FormContainer />,
  },
  {
    id: 28,
    path: "form/4",
    element: <RegisterForm />,
  },

  {
    id: 29,
    path: "practice/debounce",
    element: <Debouncedemo />,
  },
  {
    id: 30,
    path: "practice/lockunlock",
    element: <LockUnLock />,
  },
  {
    id: 30,
    path: "/practice/multiselected",
    element: <MultiSelectDropDown />,
  },
  {
    id: 31,
    path: "practice",
    element: <PracticeHome />,
  },
];
